module.exports = __webpack_public_path__ + "static/media/MIAB9600-180730-81_Small.c7e6c601.jpg";